<template lang="pug">
.navigation
  .pointer(:class="{hidden: !data.prevPage}" @click="getPage(data.prevPage)")
    .number-container
      img.arrow.left(src="@/assets/right.svg" alt="prev")
  div(:class="{hidden: !data.page}")
    .number-container.active {{ data.page }}
  .pointer(:class="{hidden: !data.nextPage}" @click="getPage(data.nextPage)")
    .number-container
      img.arrow(src="@/assets/right.svg" alt="next")
</template>

<script>
export default {
  name: 'Navigation',

  props: {
    data: Object
  },

  methods: {
    getPage (page) {
      this.$emit('getPage', page)
    }
  }
}
</script>

<style lang="stylus" scoped>
.navigation
  display flex
  justify-content space-between
  margin-top 1rem
  padding 0 .9rem
  margin-bottom 2rem

.number-container
  display inline-flex
  align-items center
  justify-content center
  width 2rem
  height 2rem
  border 1px solid #c8c8c8
  border-radius .5rem

.number-container.active
  background-color #e9e9e7
  border none

.number-container .arrow
  width 1rem
  height 1rem

.arrow.left
  transform rotate(180deg)
</style>



// WEBPACK FOOTER //
// src/components/helpers/Navigation.vue